import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Button,
  Icon,
} from 'semantic-ui-react';
import facebookLogo from "../../components/Layout/facebook.png";
import instagramLogo from "../../components/Layout/instagram.png";
import draxLogo from "../../components/Layout/logo2.png";
import naverLogo from "../../components/Layout/naver.png";
import "./solutions.css";

const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;

interface Solution {
  id: number;
  solution: string;
  solution_detail: string;
  isActive: boolean;
  model: number[];
  reg_date: string;
  view_count: number;
  edit_date: string;
  categoryname: string;
}

const Solutions = () => {
  const navigate = useNavigate();
  const id = useParams();

  const [solutions, setSolutions] = useState<Solution[]>([]);
  const [title, setTitle] = useState<string>('');
  const [content, setContent] = useState<string>('');
  const [viewCount, setViewCount] = useState<number>(0);
  const [regDate, setRegDate] = useState<string>('');

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };


  useEffect(() => {
    axios.get(`${apiEndpoint}/receiption/api/solutions/`,{params: {id: id.solutionsId}})
      .then(response => {
        const resSolution = response.data.map((solution: Solution) => {
          return {
            id: solution.id,
            solution: solution.solution,
            solution_detail: solution.solution_detail,
            isActive: solution.isActive,
            model: solution.model,
            regDate: new Date(Date.parse(solution.reg_date)).toLocaleDateString(undefined, options).slice(0, -1),
            viewCount: solution.view_count,
            editDate: new Date(Date.parse(solution.edit_date)).toLocaleDateString(undefined, options).slice(0, -1),
            categoryname: solution.categoryname,
          }
        });

        setSolutions(resSolution);
        setTitle(resSolution[0].solution);
        setContent(resSolution[0].solution_detail);
        setViewCount(resSolution[0].viewCount);
        setRegDate(resSolution[0].regDate);
        return resSolution;

      })
      .catch(error => {
        console.error('API 호출 중 오류 발생:', error);
      });
  },[]);

  const onClickHandler = () => {
    const textArea = document.createElement("textarea");
    textArea.value = window.location.href;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      alert('클립보드에 복사되었습니다.');
    } catch (err) {
      console.error('클립보드 복사 중 오류 발생:', err);
    }
    document.body.removeChild(textArea);
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center",}}>
      <div style={{ width: "90%", maxWidth: "800px", }}>

        {/* header */}
        <h1 className="align-center my-4" style={{cursor:'pointer'}} onClick={() => navigate('/')}>스스로해결</h1>

        <div className="ui divider"></div>

        {/* contents */}
        <div className='p-2'>
          <h2 className='p-2'>{title}</h2>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {regDate} | 조회 {viewCount}
            <div>
              <div><Icon style={{'cursor':'pointer'}} onClick={onClickHandler} className='align-right' name='paperclip'></Icon></div>
            </div>
          </div>
        </div>
        <div className="ui divider"/>

        <div>
          <div className="information card">
            <div dangerouslySetInnerHTML={{ __html: content }}/>
          </div>
        </div>

        {/* footer */}

        <div className='px-5 align-center' >
          <Button color='orange' size='big' onClick={() => navigate('/solutions')}><Icon name='bars'></Icon> 목록 </Button>
        </div>
        {/* footer */}
        <div className="ui divider"/>
        <div className="information2 row" style={{ display: "flex" }}>
          <div
            style={{
              width: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: '0',
              paddingTop: '0',
              paddingBottom: '1rem'
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
              <div style={{ flex: '0 0 80%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80%' }}>
                <img
                  src={draxLogo}
                  alt="Drax"
                  className="py-1"
                  style={{ width: '100%', height: 'auto', maxWidth: '200px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.draxfit.com/', '_blank')}
                />
              </div>
              <div style={{ flex: '0 0 20%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20%' }}>
                <img
                  src={naverLogo}
                  alt="Naver"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://blog.naver.com/draxfit_official/', '_blank')}
                />
                <img
                  src={instagramLogo}
                  alt="Instagram"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.instagram.com/draxfit_official/', '_blank')}
                />
                <img
                  src={facebookLogo}
                  alt="Facebook"
                  className="px-2"
                  style={{ width: '40px', height: '30px', cursor: 'pointer' }}
                  onClick={() => window.open('https://www.facebook.com/DRAXFIT/', '_blank')}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              width: "50%",
              textAlign: 'left',
              fontSize: '0.75rem',
              paddingBottom: '1.5rem',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
            <div style={{ fontWeight: 'bold', fontSize: '1.5rem', marginBottom: '8px' , marginTop: '27px'}}>주식회사 디랙스</div>
            <div style={{ marginBottom: '0.5px' }}>본사/제1공장 : 경기 안양시 만안구 전파로62번길 26</div>
            <div style={{ marginBottom: '0.5px' }}>제2공장 : 경기 안양시 만안구 전파로 48</div>
            <div style={{ marginBottom: '0.5px' }}>제3공장 : 경기 안양시 만안구 덕천로72번길 85</div>
            <div style={{ marginBottom: '0.5px' }}>사업자등록번호 123-81-70002</div>
            <div style={{ marginBottom: '0.5px' }}>TEL: 031-459-8530 / FAX: 031-459-8531</div>
          </div>
        </div>
        {/* footer */}
      </div>
    </div>
  )
}

export default Solutions;